export { RuleId } from './types-v2';
export let MainHeadingFailedReason = /*#__PURE__*/function (MainHeadingFailedReason) {
  MainHeadingFailedReason["MultipleMainHeadings"] = "MultipleMainHeadings";
  MainHeadingFailedReason["NoMainHeading"] = "NoMainHeading";
  return MainHeadingFailedReason;
}({});
export let HeadingStructureFailedReason = /*#__PURE__*/function (HeadingStructureFailedReason) {
  HeadingStructureFailedReason["MultipleMainHeadings"] = "MultipleMainHeadings";
  HeadingStructureFailedReason["NoMainHeading"] = "NoMainHeading";
  HeadingStructureFailedReason["HeadingDefinition"] = "HeadingDefinition";
  return HeadingStructureFailedReason;
}({});
export let AltTextFailedReason = /*#__PURE__*/function (AltTextFailedReason) {
  AltTextFailedReason["EmptyAltText"] = "EmptyAltText";
  AltTextFailedReason["HasImageExtension"] = "HasImageExtension";
  return AltTextFailedReason;
}({});
export let ValidPageTitleFailedReason = /*#__PURE__*/function (ValidPageTitleFailedReason) {
  ValidPageTitleFailedReason["CopyOf"] = "CopyOf";
  ValidPageTitleFailedReason["Copy"] = "Copy";
  ValidPageTitleFailedReason["NewPage"] = "NewPage";
  ValidPageTitleFailedReason["Empty"] = "Empty";
  ValidPageTitleFailedReason["Length"] = "Length";
  return ValidPageTitleFailedReason;
}({});
//# sourceMappingURL=types.js.map